module.exports = __webpack_public_path__ + "static/media/volunteer_icon_dark.ed295a22.svg";